var styles = {"PreviewList":"styles-module_PreviewList__-Aqbp","Preview":"styles-module_Preview__urafm","PreviewClose":"styles-module_PreviewClose__B5cT1","Loader":"styles-module_Loader__EJMJj"};

export { styles as default };
